import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overview-itinerary',
  templateUrl: './overview-itinerary.component.html',
  styleUrls: ['./overview-itinerary.component.scss'],
})
export class OverviewItineraryComponent  implements OnInit {

  constructor() { }

  ngOnInit() {}

}
